import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { mediaList } from "@/mocks/media";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import ContinueWatching from "@/pages/home/components/ContinueWatching";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import HotRecommend from "@/pages/home/components/HotRecommend";
import IntroSection from "@/pages/home/components/IntroSection";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import NewsSection from "@/pages/home/components/NewsSection";

const HOME_TITLE = "97视频 - 高清影视视频内容聚合平台";
const HOME_DESCRIPTION =
  "97视频为您提供丰富的影视视频内容，涵盖电影、电视剧、综艺等多种类别，方便用户浏览和了解最新影视动态。";
const HOME_KEYWORDS = "97视频,影视视频,电影,电视剧,综艺节目,影视资讯,高清视频";

export default function Home() {
  useSeo(HOME_TITLE, HOME_DESCRIPTION, HOME_KEYWORDS);

  const featured = mediaList.filter((item) => item.featured).slice(0, 4);

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />
      <div className="relative -mt-px">
        <div className="pt-10 md:pt-12">
          <CategoryEntries />
        </div>
        <LatestUpdates />
        <HotRecommend />
        <NewsSection />
        <ContinueWatching />
        <IntroSection />
      </div>
    </SiteLayout>
  );
}